import { Center, ChakraProps, Grid, GridItem, Heading } from '@chakra-ui/react';
import { OutputLocation } from '@ssar-app/domain';

export interface OutputLocationsSummaryProps {
  outputLocations: OutputLocation[];
}

const headerStyle: ChakraProps = {
  fontWeight: '700',
  textAlign: 'center',
  border: '1px solid rgba(29,79,145, .3)',
  p: 2,
};

const rowHeaderStyle: ChakraProps = {
  fontWeight: '700',
  textAlign: 'left',
  border: '1px solid rgba(29,79,145, .3)',
  p: 2,
};

const rowNormalStyle: ChakraProps = {
  textAlign: 'left',
  border: '1px solid rgba(29,79,145, .3)',
  p: 2,
};

export const OutputLocationsSummary = (props: OutputLocationsSummaryProps) => {
  const { outputLocations } = props;
  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={8}
        marginBottom={2}
        fontSize={'sm'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Output File
      </Heading>
      <Center>
        <Grid
          templateColumns={`repeat(${outputLocations.length}, 0.5fr)`}
          border='1px solid rgba(29,79,145, .3)'
          maxW={'fit-content'}
        >
          <GridItem colSpan={outputLocations.length + 1} {...headerStyle}>
            Output File Information
          </GridItem>

          <GridItem {...rowHeaderStyle}></GridItem>
          {outputLocations.map((_value, index) => {
            return (
              <GridItem key={`OFILocation${index}`} {...rowHeaderStyle}>
                Location {index + 1}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Delimiter</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`Delimiter${index}`} {...rowNormalStyle}>
                {outputLocation.delimiter || '-'}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Main File</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`MainFile${index}`} {...rowNormalStyle}>
                {outputLocation.mainFile?.isNeeded
                  ? outputLocation.mainFile?.name || '-'
                  : '-'}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Reject File</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`RejectFile${index}`} {...rowNormalStyle}>
                {outputLocation.rejectFile?.isNeeded
                  ? outputLocation.rejectFile?.name || '-'
                  : '-'}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Statement File</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`StmtFile${index}`} {...rowNormalStyle}>
                {outputLocation.statementFile?.isNeeded
                  ? outputLocation.statementFile?.name || '-'
                  : '-'}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Zipped File</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`ZipFile${index}`} {...rowNormalStyle}>
                {outputLocation.zippedFile?.isNeeded
                  ? outputLocation.zippedFile?.name || '-'
                  : '-'}
              </GridItem>
            );
          })}

          <GridItem colSpan={outputLocations.length + 1} {...headerStyle}>
            Output Shipment Information
          </GridItem>

          <GridItem></GridItem>
          {outputLocations.map((_outputLocation, index) => {
            return (
              <GridItem key={`OSILocation${index}`} {...rowHeaderStyle}>
                Location {index + 1}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Delivery To</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`DeliveryTo${index}`} {...rowNormalStyle}>
                {outputLocation.target}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Output Folder</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem
                key={`OutputFolder${index}`}
                {...rowNormalStyle}
                wordBreak={'break-all'}
              >
                {outputLocation.location}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Contact Name</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`ContactName${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.name}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Company Name</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`CompanyName${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.clientName}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Email</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`Email${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.email}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Address</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`Address${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.address}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>City</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`City${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.city}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>State</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`State${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.state}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Zip Code</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`ZipCode${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.zipCode}
              </GridItem>
            );
          })}

          <GridItem {...rowHeaderStyle}>Phone number</GridItem>
          {outputLocations.map((outputLocation, index) => {
            return (
              <GridItem key={`PhoneNumber${index}`} {...rowNormalStyle}>
                {outputLocation.contact?.phoneNumber || '-'}
              </GridItem>
            );
          })}
        </Grid>
      </Center>
    </>
  );
};
